import { useMutation } from "@tanstack/react-query";
import { updateTradingAllocation } from "services";

export const useTradingAllocation = (onSuccess, onError) => {
  return useMutation({
    mutationFn: ({ brokerAccountId, payload }) => {
      return updateTradingAllocation(brokerAccountId, payload);
    },
    onSuccess,
    onError,
  });
};
